import React, { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import VesselMap from "./VesselMap";

const LatestStatus = ({ latestStatus, lastVoyage }) => {
  const [isOpen, setIsOpen] = useState(true);
  console.log("lateststatus", latestStatus);
  if (!latestStatus) {
    return (
      <div className="rounded-lg border border-gray-200 p-4">
        Loading status data...
      </div>
    );
  }

  const formatNumber = (num, decimals = 1) => {
    if (num === null || num === undefined) return "N/A";
    return num.toFixed(decimals);
  };

  const statusData = [
    {
      label: "STW (kts)",
      value: formatNumber(latestStatus.speedThroughwater),
    },
    {
      label: "SOG (kts)",
      value: formatNumber(latestStatus.speedOverGround),
    },
    {
      label: "Displacement (tn)",
      value: latestStatus.displacement?.toLocaleString() || "N/A",
    },
  ];

  // Updated loading data mapping
  const loadingData = [
    {
      label: "Forward Draft (m)",
      value: formatNumber(latestStatus.forwardDraft),
    },
    { label: "Mid Draft (m)", value: formatNumber(latestStatus.midDraft) },
    { label: "Aft Draft (m)", value: formatNumber(latestStatus.aftDraft) },
  ];

  // Updated zone data mapping
  const zoneData = [
    {
      label: "Heading (deg)",
      value: formatNumber(latestStatus.headingDeg, 0),
    },
    {
      label: "COG (deg)",
      value: formatNumber(latestStatus.cogDegree, 0),
    },
    { label: "Trim (m)", value: formatNumber(latestStatus.trim) },
  ];

  const renderStatusRow = () => (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 pb-4">
      <div className="lg:col-span-3 bg-[#dcecf8] p-4 rounded">
        <div className="text-base mb-1">Status</div>
        <div className="text-[#27ade3] text-base font-normal">
          {latestStatus.status || "N/A"}
        </div>
      </div>
      <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-center">
        {statusData.map((item, idx) => (
          <div key={idx} className="min-w-0">
            <div className="text-[#0a2540] text-sm font-medium mb-2">
              {item.label}
            </div>
            <div className="text-[#27ade3] text-sm font-medium">
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderLoadingRow = () => (
    <div className="border-y border-gray-300 py-4">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-3 bg-[#dcecf8] p-4 rounded">
          <div className="text-base mb-1">Zone</div>
          <div className="text-[#27ade3] text-base font-normal">
            {latestStatus.type || "N/A"}
          </div>
        </div>
        <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-center">
          {loadingData.map((item, idx) => (
            <div key={idx} className="min-w-0">
              <div className="text-[#0a2540] text-sm font-medium mb-1 break-words">
                {item.label}
              </div>
              <div className="text-[#27ade3] text-sm font-medium break-words">
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderZoneRow = () => (
    <div className="py-4">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-3 bg-[#dcecf8] p-4 rounded">
          <div className="text-base mb-1">Cargo Status</div>
          <div className="text-[#27ade3] text-base font-normal">
            {latestStatus.loadCondition || "N/A"}
          </div>
        </div>
        <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-center">
          {zoneData.map((item, idx) => (
            <div key={idx} className="min-w-0">
              <div className="text-[#0a2540] text-sm font-medium mb-2">
                {item.label}
              </div>
              <div className="text-[#27ade3] text-sm font-medium">
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      <div
        className="flex justify-between items-center px-4 py-4 cursor-pointer bg-gradient-to-r from-[#1a325d] to-[#27ade3]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h2 className="text-white text-lg font-normal">
          Latest <span className="font-semibold">Status</span>
        </h2>
        <button className="p-1">
          {isOpen ? (
            <ChevronUp size={20} color="#fff" />
          ) : (
            <ChevronDown size={20} color="#fff" />
          )}
        </button>
      </div>
      {isOpen && (
        <div className="flex flex-col lg:flex-row">
          <div className="flex-1 p-4 bg-gradient-to-tr from-white to-[#d9ebff] border-t border-[#27aee38a]">
            {renderStatusRow()}
            {renderLoadingRow()}
            {renderZoneRow()}
          </div>
          <div className="lg:w-96 lg:flex-shrink-0 p-4 lg:pr-4 lg:py-4 lg:pl-0">
            <VesselMap lastVoyage={lastVoyage} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LatestStatus;
